import { set } from '@/utils/vuex'
export default {
  listDossiersRecords: set('listDossiersRecords'),
  listDossiersState: set('listDossiersState'),
  editDossierState: set('editDossierState'),
  addDossiersState: set('addDossiersState')
}
